import { AbstractControl, AsyncValidatorFn, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';

import { ChangeDetectorRef, Injectable } from '@angular/core';
import { map, debounceTime, tap, take, switchMap } from 'rxjs/operators';
import { DrugService } from '@nrwl/rx-service-drug';

@Injectable({
  providedIn: 'root',
})
export class PhotosValidatorsService {
  constructor(private drugService: DrugService) {}

  /**
   * @TODO remove  changeDetection
   * this parameter was added because otherwise in rx-input always status pending
   */
  public checkName(oldValue: string | any, changeDetection?): AsyncValidatorFn | any {
    return (control: FormGroup): Observable<{ [key: string]: any } | null> => {
      const value = control.value;

      if (control.pristine) {
        return of(null);
      }

      if (value === oldValue) {
        return of(null);
      }

      return control.valueChanges.pipe(
        debounceTime(500),
        take(1),
        switchMap((value) => this.drugService.getDrugs()),
        map((data) => {
          const existingDrug = data.find((drug) => drug.name === value);

          if (existingDrug) {
            return { exists: true };
          }

          return null;
        }),
        tap(() => {
          control.markAsTouched();
          setTimeout(() => {
            if (changeDetection) changeDetection.detectChanges();
          });
        }),
      );
    };
  }
}
